import React from 'react';
import { ReactComponent as Loading } from '../../../assets/puff.svg';

export default function LoadingOverlay({ text, theme = 'light' }) {
  return (
    <div className={`loading-overlay loading-overlay--${theme}`}>
      <Loading />
      <span className='loading-overlay__text'>{text}</span>
    </div>
  );
}
